<template>
  <!-- 老一键购、常规一键购、新一键购 增加了底部倒计时，吸底，所以增加padinggBottom -->
  <div class="product-item not-select" :class="{'product-item__oneshoping': isShowSellCountDown, 'product-item--hide': skuOpen == 2}" v-if="allowShow">
    <!-- 账号 -->
    <Logout v-if="isShowLogout" type="course"/>

    <top-bar-nav
      :posIndex="posIndex"
      :ajaxOk="ajaxOk"
      @clickNav="clickNav"
      v-show="showTopbar">
      <!--showType:0-长图,1-评论-->
    </top-bar-nav>

    <!-- 课程头图 课程评价 课程详情-->
    <CourseContent
      ref="content"
      :isLogin="userReallyOnline"
      :headColor="goodsDetail.headColour"
      :goodsDetail="goodsDetail"
      :showTypeTrue="showTypeTrue"
      :infoList="productInfo"
      :detailList="detailInfo"
      :commentList="commentlistData" />

    <shop-car-v2
      ref="sepcilPanel"
      :show.sync="showCar"
      :groupBuyMark="group_buy_mark"
      :ptActualPrice="ptActualPrice"
      :detail="goodsDetail"
      :realPrice="realPrice"
      :ptMaidian="ptMaidian"
      :otherQuery="otherQuery"
      :ptLadderList="ptInfo.ptLadderList"
      :firstSelectSkuDiscountPrice="firstSelectSkuDiscountPrice"
      :fqBuyMark="fqFlagMark"
      buyType="singBuy"
      :userReallyOnline="userReallyOnline"
      @onLogin="handleSpecilPanelLogin"
      @onPlaceOrder="handlePlaceOrder"
    ></shop-car-v2>
    <BottomBtn
      v-if="ajaxOk"
      :itemid="itemid"
      :goodsDetail="goodsDetail"
      :shopping="goodsDetail.isSupportShopCart"
      :ptFlag="ptFlag"
      :firstSelectSkuDiscountPrice="firstSelectSkuDiscountPrice"
      :firstSelectSkuVipCouponUse="firstSelectSkuVipCouponUse"
      :realPrice="realPrice"
      :ptPrice="ptPrice"
      :btnText="btnText"
      :ptRbtnText="ptRbtnText"
      :dataHasPtAuth="dataHasPtAuth"
      :hasPtAuth="hasPtAuth"
      :initGroupBuyMark="initGroupBuyMark"
      :userReallyOnline="userReallyOnline"
      :shoppingCount="shoppingCount"
      :isNoParamsCourse="isNoParamsCourse"
      :danbaoSwitch="danbaoSwitch"
      :btnStatus="btnStatus"
      :couponUseType="firstSelectSkuCouponUseType"
      :openVipInfo="openVipInfo"
      @toLogin="toLogin"
      @goShoppingCar="goShoppingCar"
      @leftClick="handleSelShoppingSpecil"
      @rightClick="openHandle"
      @exchangeVip="exchangeVip"
    />
    <!-- <BottomLoading v-else :ptFlag="ptFlag" :goodsDetail="preloadData"></BottomLoading> -->

    <!-- 右上角的客服、我的订单 -->
    <FixedShrink
      v-if="goodsDetail.floatSwitch"
      @clickTool="clickTool"
      @goToOrder="goToOrder"
      @goToIM="goToIM"
      :goodsDetail="goodsDetail"
      :ptInfo="ptInfo"
      :userReallyOnline="userReallyOnline"
      v-drag
    ></FixedShrink>

    <div class="lianbao-btn">
      <img
        :src="item.imgUrl"
        alt
        v-for="(item,index) in relationSaleRespDTOList"
        :key="index"
        @click="goToLianbao($event,item.jumpUrl)"
      />
    </div>

    <!-- 砸金蛋(活动前置优惠配置) 的金蛋 -->
    <div class="gift-modal" v-if="showGiftModal">
      <div class="gift-modal-content">
        <transition name="gift">
          <div :class=" styleType ? 'img-gift-wrap_n' : 'img-gift-wrap'" v-if="showGiftCard">
            <p class="title">{{ activityDetailCouponPrepose.couponTitle }}</p>
            <p class="title-name"><span class="num">{{ userCouponInfoRespDto.fullMoneyReduce }}</span> <span
              class="unit">元</span>
            </p>
            <p class="range">适用范围：</p>
            <p class="range-name">{{ userCouponInfoRespDto.directionForUse }}</p>
            <p class="get-gift" @click="goGetGift"></p>
            <p class="time-item"> {{countDownTextDynic}}：{{ timeArr[0] }}天{{ timeArr[1] }}时{{ timeArr[2] }}分{{ timeArr[3] }}秒</p>
          </div>
        </transition>
      </div>
    </div>
    <HuabeiCeng :show.sync="showHuabeiGui" />
    <!-- 拼团说明 -->
    <van-popup
      v-model="showPtPop"
      position="bottom"
      class="pop_content"
      @close="showPtPop = false"
    >
      <div class="main">
        <i-del-tag class="close_icon" @click.native="showPtPop = false" />
        <h3 class="title">参团说明</h3>
        <div class="content">
          {{ptInfo.purchaseLimitDesc}}
        </div>
      </div>
    </van-popup>
    <!-- 左上角 已报名 轮播 -->
    <BuyNotice v-if="isPhoneRoll"/>
    <!-- 底部 剩余名额 倒计时 -->
    <Countdown
      v-if="isShowSellCountDown"
      fixed safe
      :during="sellDuring"
      :timeLeft="sellCountDownDuring"
      :format="['h', 'm', 's']"/>

    <!-- 加购时选择商品规格 -->
    <MallSpecilPopup v-model="isShowShoppingSpecil" :goodsData="goodsDetail" @onConfirm="handleConfirmShopping"/>

    <!-- vip会员权益兑换弹窗 -->
    <VipBenefits
      :show="vipPopShow"
      :changeSucc="changeSucc"
      :info="exchangePoolInfo"
      @closePop="() => {
        this.setTrack({
          module_name: '兑换弹窗',
          item_name: '取消',
          btn_name: '取消',
          key1: {
            inCoursePool: this.exchangePoolInfo.defaultPoolId ? 1 : 0,
            exchangeNum: this.exchangePoolInfo.defaultCanChangeCount ? 1 : 0,
            inUserPool: 1,   // 是否符合人群
          }
        }, 'click');
        vipPopShow=false
      }"
      @sureChange="sureChange"
      @goCourse="() => {
        this.setTrack({
          module_name: '兑换成功弹窗',
          item_name: '去学习',
          btn_name: '去学习',
          key1: {
            inCoursePool: this.exchangePoolInfo.defaultPoolId ? 1 : 0,
            exchangeNum: this.exchangePoolInfo.defaultCanChangeCount ? 1 : 0,
            inUserPool: 1,   // 是否符合人群
          }
        }, 'click');
        vipPopShow=false
        handleSelShoppingSpecil(2)
      }"
    />
  </div>
  <CoolMLoading
      v-else
      :show="true"
      text="正在维护中..."
      bgColor="rgba(0, 0, 0, .7)"/>
</template>

<script>
/* eslint-disable */

/**
 * 商品详情页
 */
import { mapState, mapActions } from 'vuex';
import { CoolMLoading } from '@igetcool/cool-mobile-ui';
import { getGoodDetailV2 as getGoodDetail, querySellType, getMutexGoods, getGroupBuyAuth, getShopPtActivityInfo, getGoodsDescContent } from '@/api/goods';
import { addShopping, getShoppingCount } from '@/api/shoppingCar';
import { leftTime2HMS } from '@/utils';
import { getCoupons, getCouponsDetail, getUserCouponsDetail } from '@/api/coupons';
import { FixedShrink, IDelTag } from '@/components/ITag';
import shopCarV2 from './components/shopCarV2';
import BottomBtn from './components/BottomBtn';
import CommentList from '@/components/comment/commentList';
import TopBarNav from '@/components/comment/topBarNav';
import { HuabeiCeng } from '@/components/IModal';
import { env, ILocalStorage, JS2Native, LogTrack, sub, webSDK, isDouyinApp, ISession, isInBaidu, coolHref } from '@utils';
import { getUser, removeUser, setUser } from '@utils/auth';
import { douyinAuth } from '@utils/douyinAuth';
import { removeCoupons } from '@utils/coupons';
import { loginCheck } from '@/api/user';
import mixin from '@/mixin/auth';
import BuyNotice from '@/components/BuyNotice';
import Countdown from '@/components/comment/countDown';
import BackPromptMixin from '@/mixin/promptMixin.js';
import { MallSpecilPopup } from '@/components/GoodsSpecil/index.js';
import VipBenefits from './components/VipBenefits.vue';
import { add } from '@utils';


import { CourseContent } from './contentComponents/index.js'

import { fastPayment } from '@utils/fastPayment';
import Logout from '@/components/logout';
import { checkOutsideAuth } from '@utils/outsideAuth';
import { getExchangePool, postExchangePoolSub, getMemberSkip } from '@/api/vip';
import { getDeviceType } from '@/utils/common';


const MAX_IMG_LIMIT = 3;
const isInBaiduBrowser = isInBaidu();

export default {
  name: 'goodItem',
  mixins: [mixin, BackPromptMixin],
  data() {
    let {
      itemid,
      igc_from: channel,
      put_type: putType,
      instructor,
      trainshare,
      temporarilyGoToMini,
      coupon_prepose,
      activityId,
      igc_from,
      campType,
      mini_camptype,
      miniMallToken,
      miniPhone,
      miniUid,
      ptFlag,
      ptActualPrice,
      skuOpen,
      igc_zid,
      abFlag,
      orderReturn,
      groupSn,
      orderSn,
      wechatMsgId,
    } = this.$route.query;
    if (igc_from === 'xxx') { igc_from = undefined }

    let userId;
    if (!env.isApp) {
      if (miniUid) {
        userId = miniUid;
      } else {
        const { uid } = JSON.parse(getUser()) || {};
        userId = uid;
      }
    }
    return {
      countDownText: '领卷截止时间',
      detailInfo: {},
      ptMaidian: {
        maddian: true
      },
      posIndex: 0,
      showTypeTrue: false,
      clickingScroll: false,
      scrollDown: false,
      channel,
      activityId,
      igc_from,
      abFlag,    // abtest标识
      campType,
      mini_camptype,
      miniMallToken,
      miniPhone,
      miniUid,
      coupon_prepose,
      timeArr: [0, 0, 0, 0],
      showGiftModal: false,
      showGiftCard: false, 
      ifReceive: false,
      styleType: 0,
      isCouponValid: false,
      activityDetailCouponPrepose: {},
      userCouponInfoRespDto: {},
      loginOnline: false,
      ajaxOk: false,
      lastPageLogin: false,
      trainshare,
      temporarilyGoToMini,
      userId,
      putType,
      itemid,
      commentId: 0,
      showCar: false,
      goodsDetail: {},
      relationSaleRespDTOList: [],
      commentlistData: [],
      isNoParamsCourse: false,                  // 是否为无规格： true 是， false 否
      instructor,
      otherQuery: {},
      hasLoad: 0,
      lastScrollTop: 0,
      group_buy_mark: false, // 是否开团购买
      initGroupBuyMark: false,
      ptFlag,
      ptActualPrice,
      ptInfo: {},
      skuOpen,               // 自动跳转到收银台 默认：push跳转， 2: replace跳转（不展示页面内容，只适用于无规格）
      igc_zid,
      firstSelectSkuDiscountPrice: 0,   // 首规格是否存在优惠券   满减 || 现金
      showHuabeiGui: false,
      fqFlagMark: false,
      dataHasPtAuth: true,
      showPtPop: false,
      shoppingCount: 0,
      countDownFlag: false,
      orderReturn,
      groupSn,  // 参团码
      orderSn,  // 参团码对应的orderID
      isShowShoppingSpecil: false,    // 加入购物车时是否开启规格面板
      goodsSpeilData: {},             // 购物车规格面板数据
      wechatMsgId,        // 公众号模板消息-拼团埋点
      governmentPrice: {
        appChannel: '',    // 渠道  
        isLogin: '',      // 是否登录
        deviceType: '',   // 设备类型 
        appVersion: ''   // 版本
      },    // 小程序专属商品价格治理需要同步APP内的价格数据，因此需要传这些参数
      vipPopShow: false,   // vip会员权益兑换弹窗是否展示
      exchangePoolInfo: {},  // 兑换信息
      firstSelectSkuVipCouponUse: 0,   // 首规格是否使用了会员券 
      openVipInfo: {},    // 开通会员信息
      loadingVisible: false,  //兑换的loading
      changeSucc: false,       // 是否兑换成功
      firstSelectSkuCouponUseType: 0,       // 首规格优惠券使用类型
      preloadData: {},                       // 预加载的数据

    };
  },
  computed: {
    ...mapState('course', ['preSaveData']),

    allowShow() { 
      if (!this.goodsDetail.name) {
        return true;
      } else {
        let itemTitle = this.goodsDetail.name;
        let result = 1;
        this.$hideWordsArray.forEach((it) => {
          if (itemTitle.indexOf(it) !== -1) {
            result--;
          }
        });
        return result > 0;
      }
    },
    ptRbtnText() {
      let text = '';
      if (this.goodsDetail) {
        if (this.goodsDetail.fqFlag && !this.ptFlag) {
          text = `分${this.goodsDetail.fqCaculateResp.term}期购买`;
        } else if (this.goodsDetail.productStatus) {
          let price = this.ptPrice[0]+'.'+ this.ptPrice[1]
          if (price == '0' || price == '0.00') {
            text = '发起拼团';
          } else {
            text = '拼团购买';
          }
        } else {
          text = '不在售卖期';
        }
      }
      return text;
    },
    hasPtAuth() {
      let has = false;
      let arr = ['NOT_JOIN_LEADER_AUTH', 'NOT_JOIN_ALL_AUTH', 'ALREADY_JOIN_PT'];
      let res = arr.find(data => {
        return data === this.ptInfo.uidPtStatusEnum;
      });
      if (res) { has = true }
      return has;
    },
    showTopbar() {
      let show;
      let { scrollDown, showTypeTrue } = this;
      if (this.ajaxOk) {
        if (showTypeTrue) {
          show = scrollDown;
        }
        if (!showTypeTrue) {
          show = false;
        }
      } else {
        show = false;
      }
      if (show) {
        this.setTrack({ module_name: '顶导bar', item_name: '顶导bar' }, 'show');
      }

      // main_item_type
      return show;
    },
    userReallyOnline() {
      return Boolean(this.loginOnline && this.userId);
    },
    getCouponBuyPrice() {
      let {
        showActualPrice,
        couponInfoDetail,
        reduceFlag,
        reducePrice
      } = this.goodsDetail;
      if (this.userReallyOnline) {
        if (reduceFlag) {
          if (showActualPrice - reducePrice >= 0) {
            showActualPrice = showActualPrice - reducePrice;
          }
        }
      }
      if (this.goodsDetail.couponUse) {
        showActualPrice = showActualPrice - couponInfoDetail.fullMoneyReduce;
        showActualPrice = +showActualPrice;
        showActualPrice = showActualPrice.toFixed(2);
        showActualPrice = showActualPrice <= 0 ? '0' : showActualPrice;
      }
      return showActualPrice;
    },
    realPrice() {
      let {
        reduceFlag,
        reducePrice,
        showActualPrice = 0,
        showOriginalPrice,
        couponInfoDetail
      } = this.goodsDetail;
      
      // reduceFlag = !reduceFlag;
      let { userReallyOnline } = this;
      if (this.goodsDetail.couponUse) {
        showActualPrice = showActualPrice - couponInfoDetail.fullMoneyReduce;
        showActualPrice = +showActualPrice;
        showActualPrice = showActualPrice.toFixed(2);
        showActualPrice = showActualPrice <= 0 ? '0' : showActualPrice;
      }
      if (userReallyOnline) {
        if (reduceFlag) {
          if (showActualPrice - reducePrice >= 0) {
            showActualPrice = showActualPrice - reducePrice;
          }
          showActualPrice = showActualPrice - this.firstSelectSkuDiscountPrice;
          showActualPrice = +showActualPrice;
          showActualPrice = showActualPrice < 0 ? 0 : showActualPrice;
          showActualPrice = showActualPrice.toFixed(2);
          return [
            this.setPrice(showActualPrice, 0),
            this.setPrice(showActualPrice, 1)
          ];
        } else {
          showActualPrice = showActualPrice - this.firstSelectSkuDiscountPrice;
          showActualPrice = +showActualPrice;
          showActualPrice = showActualPrice < 0 ? 0 : showActualPrice;
          showActualPrice = showActualPrice.toFixed(2);
          return [
            this.setPrice(showActualPrice, 0),
            this.setPrice(showActualPrice, 1)
          ];
        }
      } else {
        if (this.goodsDetail.sellType == 5) {
          return [
            this.setPrice(showActualPrice, 0),
            this.setPrice(showActualPrice, 1)
          ];
        }
        if (reduceFlag) {
          if (showActualPrice - reducePrice >= 0) {
            showActualPrice = showActualPrice - reducePrice;
          }
        }
        showActualPrice = showActualPrice - this.firstSelectSkuDiscountPrice;
        showActualPrice = +showActualPrice;
        showActualPrice = showActualPrice < 0 ? 0 : showActualPrice;
        showActualPrice = showActualPrice.toFixed(2);
        return [
          this.setPrice(showActualPrice, 0),
          this.setPrice(showActualPrice, 1)
        ];
      }
    },
    huabeiPrice() {
      if (this.goodsDetail.fqCaculateResp && this.goodsDetail.fqCaculateResp.termPrincipalAmount) {
        let termPrincipalAmount = this.goodsDetail.fqCaculateResp.termPrincipalAmount.toFixed(2);
        return [
          this.setPrice(termPrincipalAmount, 0),
          this.setPrice(termPrincipalAmount, 1)
        ];
      }
      return ['0', '00'];
    },
    ptPrice() {
      if (this.ptInfo && this.ptInfo.ptLadderList) {
        let tempArr = Object.assign([], this.ptInfo.ptLadderList);
        tempArr.sort((a, b) => {
          return a.ladderPrice - b.ladderPrice;
        });
        let ptActualPrice = parseFloat(this.ptActualPrice || tempArr[0].ladderPrice);
        ptActualPrice = parseFloat(ptActualPrice).toFixed(2);
        return [
          this.setPrice(ptActualPrice, 0),
          this.setPrice(ptActualPrice, 1)
        ];
      }
      return [];
    },
    showToolBox() {
      return !env.isApp || this.userId;
    },
    reducePrice() {
      const goodsDetail = this.goodsDetail;
      if (goodsDetail.reduceFlag) {
        const result = sub(
          goodsDetail.showActualPrice,
          goodsDetail.reducePrice
        );
        return result > 0 ? result.toFixed(2) : '0.00';
      }
      return '0.00';
    },
    showOrderList() {
      return !env.isApp;
    },
    btnText() {
      const goods = this.goodsDetail;
      let text = '';
      if (this.isNoParamsCourse) {
        const { specilMapping } = goods;
        if (specilMapping && !specilMapping[0].stockNum) {
          text = '已售罄';
        }
      }
      if (goods.productStatus) {
        if (goods.couponUse && !this.activityId) {
          text = `${goods.ifReceived ? '用券' : '领券'}购买`;
        } else {
          text = goods.btnText || '立即购买';
        }
      } else {
        text = '不在售卖期';
      }
      return text;
    },
    productInfo() {
      // const productInfo = this.goodsDetail.productInfo;
      const productInfo = this.preloadData.content;
      if (this.preloadData.shopGoodsVersion == 2) {
        return productInfo ? JSON.parse(productInfo) : {};
      }
      const courseInfo = productInfo ? JSON.parse(productInfo) : [];
      let hasVideo = 0;
      for (let i = 0; i < MAX_IMG_LIMIT; i++) {
        const item = courseInfo[i];
        item && item.videoUrl && hasVideo++;
      }
      return this.hasLoad < MAX_IMG_LIMIT
        ? courseInfo.slice(0, MAX_IMG_LIMIT + hasVideo)
        : courseInfo;
    },
    isRedirectToOrderDetail() {
      return this.groupSn && this.orderSn && !this.orderReturn
    },
    // 是否是简化0元领取流程
    isSimpleProcess() {
      return this.goodsDetail.isSimplifyFlow && !this.ptFlag;
    },
    isShowLogout() {
      return this.goodsDetail.sellType == 1 && this.userReallyOnline && !env.isApp;
    },
    // 动态展示前置卷倒计时文案
    countDownTextDynic() {
      return this.countDownText || '领券失效时间';
    },
    // 拼团是否关闭单独购买
    danbaoSwitch() {
      return this.ptInfo?.ptActivityBasicRespDto?.danbaoSwitch;
    },
    // 按钮动效
    btnStatus() {
      return this.ptInfo?.ptActivityBasicRespDto?.btnStatus;
    },

    /**
     * 有会员使用类型 1-会员价 2-早鸟价 3-优惠价 4-券后价 5-立减价
     * 1.权益价（多个共存 存在会员券取会员价 ）1
     * 2.早鸟价（仅存在早鸟价叫早鸟价） 活动立减2
     * 3.优惠价 （优惠券+立减，多个共存并且包括早鸟价）3
     * 4.券后价 （满减或者现金）1
     * 5.立减价（文案读取立减配置，仅存在立减）
     */
    // couponUseType() {
    //   let type = 0;
    //   if(this.firstSelectSkuVipCouponUse) {
    //     // 有会员
    //     type = 1;
    //   } else if(this.firstSelectSkuDiscountPrice) {
    //     // 存在现金 || 满减
    //     if(this.goodsDetail.showCouponPrice) {
    //       // 后台配置是否展示券后价  1-展示 0-不展示
    //       type = 4;
    //     }
    //     if(this.goodsDetail.reduceFlag || this.goodsDetail.birdPrice) {
    //       // 优惠券+立减
    //       type = 3;
    //     }
    //   } else if(this.goodsDetail.birdPrice) {
    //     // 是否存在早鸟价，若存在仅读取早鸟价
    //     type = 2;
    //   } else if(this.goodsDetail.reduceFlag){
    //     // 仅存在立减价格
    //     type = 5;
    //   }
    //   return type;
    // }

  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query;
        if (query.spm) {
          query.spm = window.encodeURIComponent(query.spm);
        }
        if (query) {
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    },
    //重定向到订单详情页
    isRedirectToOrderDetail: {
      handler(n) {
        if(n) {
          this.goGroupBuyShare()
        }
      },
      immediate: true
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/mall/login') {
      next(vm => {
        vm.lastPageLogin = true;
      });
    } else {
      next();
    }
  },
  async created() {
    this.setRootLoading(true);
    
    // @aigc:start 2024/11/22-15:00
    // 获取图文详情
    getGoodsDescContent({infoId: this.itemid}).then(res => {
      if (res.code === 10000) {
        this.preloadData = res.data;
        // var loading = document.getElementById('newLoading');
        // loading.style.display = 'none';
      }
    })
    // @aigc:end 2024/11/22-15:00

    // @aigc:start 2024/05/20-16:33
    if (env.isWeChat) {
      webSDK.setWeChatMenu({
        showAllNonBaseMenuItem: true,
      });
    }
    // @aigc:end 2024/05/20-16:33

    this.orderReturn = ISession('isRedirectToOrderDetail');
    // 保存外部登陆信息（未来汽车）
    const outsideAuth = await checkOutsideAuth(this.$route.query);
    if (outsideAuth) {
      this.uId = outsideAuth;
      this.userId = outsideAuth;
    }

    removeCoupons();
    this.setLocalStorage();
    if (env.isApp) {
      this.inAppGetUserInfo();
    } else {
      this._loginCheck();
    }
  },
  methods: {
    ...mapActions('course', ['acGetPresale']),
    // 去拼团详情（参团分享）页面
    goGroupBuyShare() {
      ISession('isRedirectToOrderDetail', 1);
      // location.href = `${location.origin}/mall/groupBuyShare?groupSn=${this.groupSn}&itemid=${this.itemid}&ptFlag=2&igc_from=${this.igc_from}&depthNum=2`
      this.$router.push(
        {
          path: '/mall/groupBuyShare',
          query: {
            groupSn: this.groupSn,
            itemid: this.itemid,
            ptFlag: 2,
            igc_from: this.igc_from,
            depthNum: 2
          },
        }
      );
    },
    setLocalStorage() {
      if (this.miniUid) {
        const userInfo = {};
        userInfo.token = this.miniMallToken;
        userInfo.uid = this.miniUid;
        userInfo.phone = this.miniPhone;
        setUser(JSON.stringify(userInfo));
      }
    },
    scrollFunc(e) {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      let cha = scrollTop - this.lastScrollTop;
      this.scrollDown = cha > 10;
      let { productWrap, commentWrap, detailWrap } = this.$refs.content.$refs;
      if (!productWrap) {
        return;
      }
      let refArr = [productWrap, commentWrap, detailWrap];
      for (let i = 0; i < refArr.length; i++) {
        let offsetTop = refArr[i].offsetTop;
        if (offsetTop - scrollTop < 48) {
          if (!this.clickingScroll) {
            this.posIndex = i;
          }
        }
      }
    },
    handleScroll() {
      if (!this.showTypeTrue) {
        return;
      }
      window.addEventListener('scroll', this.scrollFunc);
    },
    clickNav(index) {
      this.setTrack({ module_name: '顶导bar', item_name: '顶导bar', btn_name: '点击bar' }, 'click');
      let { productWrap, commentWrap, detailWrap } = this.$refs.content.$refs;
      if (!productWrap) {
        return;
      }
      let refArr = [productWrap, commentWrap, detailWrap];
      this.clickingScroll = true;
      let scrollTop = refArr[index].offsetTop;
      document.body.scrollTop = scrollTop - 48;
      document.documentElement.scrollTop = scrollTop - 48;
      this.posIndex = index;
      setTimeout(() => {
        this.clickingScroll = false;
      }, 500);
    },
    goGetGift() {
      this.setLogTrack({ btn_name: '点击弹窗', module_name: '弹窗', item_name: '优惠券弹窗' }, 'click');
      
      // 大金蛋领取优惠券 领取操作
      if (env.isApp && !this.userReallyOnline) {
        this.toLogin();
      } else {
        const { uid } = JSON.parse(getUser()) || {};
        let params = { goodsId: this.itemid, uid: uid, couponId: this.userCouponInfoRespDto.couponId, activityId: this.activityId };
        getCoupons(params).then((result) => {
          this.$coolToast({ text: '领取成功' });
          this.goodItemRequest();
          this.showGiftCard = false;
          setTimeout(() => {
            this.showGiftModal = false;
          }, 888);
        }).catch((err) => {
          if (err.message === 'Network Error') {
            this.$coolToast({ text: '请检查网络连接' });
          } else {

            // this.$coolToast({ text: err.msg });
            this.showGiftCard = false;
            setTimeout(() => {
              this.showGiftModal = false;
            }, 888);
          }
        });
      }
    },
    _loginCheck() {
      if (this.miniUid) {
        this.loginOnline = true;
        this._getCouponsDetail(true);
        this.goodItemRequest();
        return;
      }

      let options = {
        infoId: this.itemid, 
        wechatMsgId: this.wechatMsgId
      }
      // if(env.isApp && this.userReallyOnline) {
      //   options = {
      //     ...options,
      //     ...this.governmentPrice
      //   }
      // }

      // 判断登陆状态、获取商品详情并行发送请求
      Promise.allSettled([
        loginCheck(),
        getGoodDetail(options),
        this.acGetPresale([this.itemid]),
      ]).then(async ([login, goods, preSave]) => {
        login.status === 'fulfilled' && (this.loginOnline = true);
        await this.getPtInfo();
        goods.value.data.goodsId = this.itemid;
        this.handleGoodsDetail(goods.value.data);
        this._getCouponsDetail(this.loginOnline);
        this.loginOnline && !this.ptFlag && this.shoppingLoginAdd();
      });
    },

    // 获取优惠券（登录、非登录）
    _getCouponsDetail(ifUser) {

      // ifUser true 已经登录 反之
      if (!this.activityId) {
        return;
      }
      let params = { goodsId: this.itemid, activityId: this.activityId };
      let ajaxFunc = getCouponsDetail;
      if (ifUser) {
        params.uid = JSON.parse(getUser()).uid;
        ajaxFunc = getUserCouponsDetail;
      }
      ajaxFunc(params)
        .then(result => {
          this.handleCoupons(ifUser, result.data);
        })
        .catch(err => {
        });
    },
    handleCoupons(ifUser, data) {

      // 处理优惠券、领取状态
      let { ifReceive, activityDetailCouponPrepose, userCouponInfoRespDto, countDownFlag, styleType, countDownText} = data;
      this.countDownText = countDownText;
      this.ifReceive = ifReceive;
      this.styleType = styleType;
      this.countDownFlag = countDownFlag;
      this.activityDetailCouponPrepose = activityDetailCouponPrepose;
      let { fullMoneyReduce } = userCouponInfoRespDto;
      if (fullMoneyReduce.indexOf('.00') !== -1) {
        userCouponInfoRespDto.fullMoneyReduce = (+fullMoneyReduce).toFixed(0);
      }
      this.userCouponInfoRespDto = userCouponInfoRespDto;
      this.handleCountown(userCouponInfoRespDto);
      this.handleCouponModalShow(activityDetailCouponPrepose.delay);
    },
    handleCouponModalShow(delay) {
      let { isCouponValid } = this;
      if (!isCouponValid && this.coupon_prepose) {
        this.setTrack({ module_name: '弹窗', item_name: '优惠券弹窗' }, 'show');
        if (this.lastPageLogin) {
          if (this.ifReceive === true) {
            this.$coolToast({ text: '您已领取过' });
          } else {
            this.goGetGift();
          }
          return;
        }
        if (this.ifReceive !== true) {
          setTimeout(() => {
            this.showGiftModal = true;
            setTimeout(() => {
              this.showGiftCard = true;
            }, 200);
          }, delay * 1000);
        }
      }
    },
    handleCountown(userCouponInfoRespDto) {
      let { overdueDate } = userCouponInfoRespDto;
      overdueDate = overdueDate.replace(/-/g, '/');
      let timeStr = (new Date(overdueDate)).valueOf();
      let now = Date.now(), cha;
      this.isCouponValid = now > timeStr;

      let todayNight = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);

      let t = setInterval(() => {
        now = Date.now();
        // cha = timeStr - now;
        cha = this.countDownFlag ? todayNight - now : timeStr - now;

        if (cha < 0) {
          this.timeArr = [0, 0, 0, 0];
          clearInterval(t);
          t = null;
          return;
        }
        this.timeArr = leftTime2HMS(cha);
      }, 1000);

    },
    goToLianbao(e, url) {
      if (url) { location.href = url }
    },
    goToMini() {
      JS2Native({
        name: 'goToMiniProgram',
        params: {
          appId: 'gh_a999ac9acbfb',
          miniProPath:
              'pages/index/index?ly_ac_id=6d591158-7fbe-11ea-8c1a-00163e06c1da'
        }
      });
    },

    // 下载图片函数
    loadImgHandle() {
      this.hasLoad++;
    },
    ptSetTrack(options = {}, type = 'show') {
      let oldOP = {
        page_name: '拼团商品详情页',
        main_item_type: '拼团',
        main_item_id: this.itemid,
        page_type: 2,
        page_title: document.title,
        url: location.href,
        mall_channel: this.igc_from
      };
      if (this.igc_zid) { oldOP.igc_zid = this.igc_zid }
      let newOP = Object.assign({}, oldOP, options);
      LogTrack.track(newOP, type);
    },
    
    toLogin(e, shoppingParams) {
      this.setTrack({ module_name: '底部', item_name: '登陆和购买按钮', btn_name: '登陆' }, 'click');
      // 2020.2.25 新增点击登陆埋点上报：判断登陆类型 e 存在表示直接调用，不存在表示通过大金蛋领取时登陆
      let btn_name = e ? (this.ptFlag ? '登录查看拼团优惠' : '登录查看优惠') : '登录砸金蛋领取优惠';
      if (e === 'shoppingLogin') {
        btn_name = '加入购物车';
      }
      this.setLogTrack({ btn_name: btn_name }, 'click');

      if (env.isApp) {
        JS2Native({
          name: 'doLogin'
        }).then(res => {
          if (res.data) {
            const uid = res.data;
            JS2Native({
              name: 'getUserInfo'
            }).then(async ({ data }) => {
              const userInfo = {};
              userInfo['App-Device-Key'] = data['App-Device-Key'];
              userInfo['App-Device-Type'] = data['App-Device-Type'];
              userInfo['App-Device-Du-Key'] = data['App-Device-Du-Key'];
              userInfo['APP-Agent'] = data['App-Version'];
              userInfo['App-Sign'] = data['App-Token'];
              userInfo['App-Channel'] = data['App-Channel'];
              userInfo['isLogin'] = data['isLogin'];
              userInfo['uid'] = uid;

              userInfo['App-Version'] = data['App-Version'];
              
              this.governmentPrice = {
                appChannel: data['App-Channel'],
                isLogin: data['isLogin'],
                deviceType: data['App-Device-Type'],
                appVersion: data['App-Version']
              }
              setUser(JSON.stringify(userInfo));
              if (e === 'shoppingLogin') {
                sessionStorage.setItem('storageShoppingCourse', JSON.stringify(shoppingParams));
              }
              this.userId = uid;
              this.loginOnline = true;

              // 获取拼团信息
              await this.getPtInfo();
              // 获取商品信息
              this.goodItemRequest();
              if (!this.ptFlag) {
                this.shoppingLoginAdd();
                // 登陆后领取前置优惠券
                this.showGiftCard && this.activityId && this.userCouponInfoRespDto && this.userCouponInfoRespDto.couponId && this.goGetGift();
              }
            });
          }
        });
      } else {
        //  加购需登录存缓存
        if (e === 'shoppingLogin') {
          sessionStorage.setItem('storageShoppingCourse', JSON.stringify(shoppingParams));
        }
        this.$router.push({
          path: '/mall/login',
          query: {
            couponUse: this.goodsDetail.couponUse ? 1 : 0,  // 登陆页埋点使用， 用来判断是否是领券购
            sellType: this.goodsDetail.sellType,            // 登陆页埋点使用， 用来判断流程类型
            ...this.otherQuery,
            itemid: this.itemid,
            redirect: this.$route.path
          }
        });
      }
    },
    goTo(href) {
      this.setTrack({ module_name: '顶导bar', item_name: '图片跳转', btn_name: '图片跳转' }, 'click');
      if (!href) { return }
      // if (this.goodsDetail.sellType != 5) {
      //   location.href = href;
      //   return;
      // }
      location.href = href;
    },

    // 购物车 ===================== begin
    // 加入购物车前选择规格
    handleSelShoppingSpecil(status) {
      let statusText = ''
      if (status === -1) {
        statusText = '即将开售';
      } else if (status === 2) {
        statusText = '去学习';
      } else {
        statusText = '加入购物车';
      }
      
      this.setLogTrack({ module_name: '底部按钮', btn_name: statusText, key1: {}}, 'click');
      
      if (status === 2) {
        this.$store.dispatch('acOpenApp', {needJump: 1, jump: 1, infoId: this.itemid});
        return;
      }
      if (status === -1) {
        return;
      }
      // 无规格，直接加购
      if (!this.goodsDetail.upSpecilName) {
        this.shoppingClick([{goodsId: this.itemid}]);
        return;
      }
      // 有规格，先拉起规格面板
      this.isShowShoppingSpecil = true;
      this.setLogTrack({ 
        module_name: '规格选择',
        key1: {
          goods_id: this.itemid,
          from: 1
        }
      }, 'show');
    },
    // 手动确认加入购物车
    handleConfirmShopping({value}) {
      this.setLogTrack({ 
        module_name: '规格确认', 
        btn_name: '确认',
        key1: {
          goods_id: this.itemid,
          sku_id: value[0]?.skuId,
          from: 1,
        }
      }, 'click');
      this.shoppingClick(value);
      this.isShowShoppingSpecil = false;
    },
    // 手动加入购物车请求
    async shoppingClick(params) {
      if (!this.userReallyOnline) {
        this.toLogin('shoppingLogin', params);
        return;
      }
      // 记录加购的igc_from
      params.forEach((item, index) => {
        item.sourceFrom = this.$route.query.igc_from || ''
        item.igcRecode = JSON.stringify(this.$route.query.igcReCode) || ''
      })

      try {
        let res = await addShopping(params);
        this.$coolToast({ text: '加购成功' });
      } catch (err) {
        if (err.data && err.data.length) {
          this.$coolToast({ text: err.data[0].errMsg });
        }
      }

      getShoppingCount({ time: Date.now() }).then(res => {
        this.shoppingCount = res.data;
      });
    },
    // 登录后自动加购物车
    async shoppingLoginAdd() {
      let storageShoppingCourse = sessionStorage.getItem('storageShoppingCourse');
      if (storageShoppingCourse && this.userReallyOnline) {
        try {
          let shoppingData = JSON.parse(storageShoppingCourse)
          // 记录加购的igc_from
          shoppingData.forEach((item, index) => {
            item.sourceFrom = this.$route.query.igc_from || '';
            item.igcRecode = JSON.stringify(this.$route.query.igcReCode) || '' ;
          });
          let res = await addShopping(shoppingData);
          sessionStorage.removeItem('storageShoppingCourse');
          this.$coolToast({ text: '加购成功' });
        } catch (err) {
          if (err.data && err.data.length) {
            this.$coolToast({ text: err.data[0].errMsg });
          }
          sessionStorage.removeItem('storageShoppingCourse');
        }

        getShoppingCount({ time: Date.now() }).then(res => {
          this.shoppingCount = res.data;
        });
      }
    },
    // 跳转到购物车
    goShoppingCar() {
      this.setLogTrack({ btn_name: '购物车', module_name: '购物车' }, 'click');
      setTimeout(() => {
        this.$router.push({
          path: '/mall/cart',
          query: {
            ...this.otherQuery
          }
        });
      });
    },
    // 购物车 ===================== end

    // 获取拼团信息
    async getPtInfo() {
      if (!this.ptFlag) {
        return;
      }
      try {
        let data = null;
        if (this.userReallyOnline) {
          data = await getGroupBuyAuth({ infoId: this.itemid, ptRoleCode: 1 }); // 登陆时
        } else {
          data = await getShopPtActivityInfo({ infoId: this.itemid });          // 未登陆时
        }
        if (data.code === 10000) {
          if (this.ptFlag == '1' && (data.data.uidPtStatusEnum === 'NOT_JOIN_MEMBER_AUTH' || data.data.uidPtStatusEnum === 'NOT_JOIN_NO_AUTH')) {
            this.dataHasPtAuth = false;
          }
          this.initGroupBuyMark = true;
          this.ptInfo = data.data;
          this.ptMaidian.active_name = this.ptInfo.ptActivityBasicRespDto.ptName;
          this.ptMaidian.active_id = this.ptInfo.ptActivityBasicRespDto.id;
          this.ptMaidian.open_group_tag = this.ptInfo.ptActivityBasicRespDto.ptLeaderLabel || -1;
          this.ptMaidian.join_group_tag = this.ptInfo.ptActivityBasicRespDto.ptMemberLabel || -1;
          this.groupSn = this.ptInfo.groupSn
          this.orderSn = this.ptInfo.orderSn
        }
      } catch (err) {
        if (err.code === 10001) {
          setTimeout(() => {
            let query = '&';
            for (let key in this.otherQuery) {
              if (key !== 'ptFlag') {
                query += `${key}=${this.otherQuery[key]}&`;
              }
            }
            query = query.substr(0, query.length - 1);
           
            if (env.isApp) {
              const domain = window.location.origin;
              const newUrl = `${domain}/mall/course?itemid=${this.itemid}${query}`;
              window.location.replace(newUrl);
            } else {
              this.$router.replace(`/mall/course?itemid=${this.itemid}${query}`);
              location.reload();
            }
          }, 1500);
        }
      }
    },
    // 半屏登陆
    handleHalfScreenLogin(callback) {
      this.setLogTrack({ btn_name: '登录查看拼团优惠' }, 'click');
      const loginSuccess = (uid) => {
        if (!uid) {
          return;
        }
        this.userId = uid;
        this.loginOnline = true;
      };
      // 客户端半屏幕登陆
      if (env.isApp) {
        JS2Native({
          name: 'doLogin',
          params: {
            type: 'window'
          }
        }).then(res => {
          if (res.data) {
            const uid = res.data;
            JS2Native({
              name: 'getUserInfo'
            }).then(({ data }) => {
              const userInfo = {};
              userInfo['App-Device-Key'] = data['App-Device-Key'];
              userInfo['App-Device-Type'] = data['App-Device-Type'];
              userInfo['App-Device-Du-Key'] = data['App-Device-Du-Key'];
              userInfo['APP-Agent'] = data['App-Version'];
              userInfo['App-Sign'] = data['App-Token'];
              userInfo['uid'] = uid;
              userInfo['App-Channel'] = data['App-Channel'];
              userInfo['isLogin'] = data['isLogin'];
              this.loginOnline = data['isLogin']
              this.governmentPrice = {
                appChannel: data['App-Channel'],
                isLogin: data['isLogin'],
                deviceType: data['App-Device-Type'],
                appVersion: data['App-Version']
              }
              this.userId = uid;
              this.loginOnline = true;
              setUser(JSON.stringify(userInfo));
              loginSuccess(uid);
              callback();
            });
          }
        });
        return;
      }

      // @aigc:start 2024/12/19-11:50
      const userShareId = this.$route.query.userShareId;
      let coolDoLoginOptions = {
        stringify: true,
        oneKeyAgree:true,

        subTitle: {
          title: '该手机号将用于开通课程',
          styles: { color: '#6D6D80' }
        },
        loginTxt: this.isSimpleProcess ? '登录领取' : '立即登录',
        showProtocol: true,
        channel: this.igc_from,
        title: '登录/注册少年得到',
      }

      if (userShareId) {
        coolDoLoginOptions = {
          ...coolDoLoginOptions,
          stringify: false,
          needBeforeLogin: true,
          beforeLogin(options) {
            // 如果用户分享id存在，则需要将用户分享id传递给后端，登陆请求走商城端
            if (userShareId) {
              options.api = '/mall-server/api/login/shopLogin';
              options.params = {
                phone: options.phone,
                smscode: options.smsCode,
                countrycode: options.countryCode,
                userShareId: userShareId
              };
              options.headers = {
                'Content-Type': 'application/json',
              };
            }
            return options;
          }
        }
      }

      this.$coolDoLogin(coolDoLoginOptions).then(res => {
        if (res.code === 10000) {
          loginSuccess(res?.data?.userId);
          callback();
        }
      });
      // @aigc:end 2024/12/19-11:50
      
    },
    // 规格面板点击登陆
    handleSpecilPanelLogin(val) {
      this.showCar = false;
      this.handleHalfScreenLogin(async () => {
        if (val.group_buy) {
          await this.getPtInfo();
        }
        // 已开过团的满足条件去开团进度页面
        if(val.group_buy && this.isRedirectToOrderDetail) {
          this.goGroupBuyShare();
          return
        }
        
        // jump 表示不再拉起规格面板，直接跳转到收银台
        this.openHandle({ ...val, jump: true });
      });
    },
    // 0元购简化流程-直接付款
    handlePlaceOrder(options) {
      let params = {uid: this.userId};
      params.deviceType = getDeviceType();
      if (this.isNoParamsCourse) {
        // 无规格
        params.mainSkuId = this.goodsDetail?.specilMapping[0]?.skuId;
        params.no_params = true;
      } else {
        // 有规格
        params.mainSkuId = options.skuId;
        params = {...params, ...options}
      }

      // @aigc:start 2024/12/19-18:33
      this.$route.query.userShareId && (params.userShareId = this.$route.query.userShareId);
      // @aigc:end 2024/12/19-18:33

      fastPayment({
        options: params,
        route: this.$route
      })
    },
    async openHandle(obj) {
      // 点击页面底部立即购买或用券购买
      this.setLogTrack({ btn_name: this.goodsDetail.productStatus ? '立即购买' : '不在售卖期' }, 'click');
      this.group_buy_mark = false;
      obj && obj.group_buy && (this.group_buy_mark = true);
 
      // 1)、拼团登陆逻辑修改，先选择规格，再进行登陆
      // 2)、0元简化流程未登陆，拉起半屏登陆
      if (!this.userReallyOnline && (this.ptFlag || this.isSimpleProcess)) {
        // 有规格，选完规格后进行登陆
        if (!this.isNoParamsCourse) {
          this.showCar = true;
          this.setLogTrack({ 
            module_name: '规格选择',
            key1: {
              goods_id: this.itemid,
              from: 2
            }
          }, 'show');
        } else {
          // 无规格，登陆后直接跳转
          this.handleHalfScreenLogin(async () => {
            await this.getPtInfo();
            this.openHandle(obj);
          });
        }
        return;
      }

      if (!this.dataHasPtAuth && obj && obj.group_buy) {
        return this.$coolToast({ text: '您不符合开团条件' });
      }
      
      if (!this.goodsDetail.productStatus) {
        return this.$coolToast({ text: this.goodsDetail.goodsType == 6 ? '商品已下架，敬请期待回归' : '当前商品不能购买' });
      }
      if (this.userReallyOnline) {
        const res = await getMutexGoods({ goodsId: this.itemid, uid: this.userId });
        if (res.data.mutex) {
          this.$coolToast({ text: '您已经购买过此类商品，不能再购买！' });
          return;
        }
        sessionStorage.setItem('mutexGoods', res.data.mutexGoods);
      }
      this.setTrack({ module_name: '顶导bar', item_name: '图片购买', btn_name: '图片购买' }, 'click');
      if (this.temporarilyGoToMini) {
        JS2Native({
          name: 'goToMiniProgram',
          params: {
            appId: 'gh_a999ac9acbfb',
            miniProPath: decodeURIComponent(this.temporarilyGoToMini)
          }
        });
        return;
      }
      let query = '&';
      for (let key in this.otherQuery) {
        if (key === 'ptFlag') {
          if (obj && obj.group_buy && this.ptFlag) {
            query += `${key}=${this.otherQuery[key]}&`;
          }
        } else {
          query += `${key}=${this.otherQuery[key]}&`;
        }
      }
      if (obj && obj.group_buy && this.ptFlag) {
        let tempArr = Object.assign([], this.ptInfo.ptLadderList);
        tempArr.sort((a, b) => {
          return a.ladderPrice - b.ladderPrice;
        });
        let selectedPtLadder = tempArr[0];
        query += `selectedPtLadder=${selectedPtLadder.idStr}&`;
        query += `actualPrice=${selectedPtLadder.ladderPrice}&`;
      }
      query = query.substr(0, query.length - 1);

      if (this.goodsDetail.sellType === 4) {
        if (obj && obj.imgClick) {
          this.setTrack({
            page_name: '老一键购页',
            module_name: '页面',
            item_name: '图片购买',
            btn_name: '图片购买'
          }, 'click');
        }

        let isInDouyinApp = isDouyinApp();
        if (isInDouyinApp) {
          douyinAuth().then(res => {
            // ISession('authInfo', JSON.stringify(res.data));
            setUser(JSON.stringify(res.data));
            this.$router.push(
              `/h5Pay/mall_compatible_order?itemid=${this.itemid}${
                this.putType ? '&put_type=1' : ''
              }${query}`
            );
          }).catch(err => {
            this.$router.push(
              `/h5Pay/mall_compatible_order?itemid=${this.itemid}${
                this.putType ? '&put_type=1' : ''
              }${query}`
            );
          });
        } else if (isInBaiduBrowser){
          // 百度浏览器，个别安卓手机在收银台获取到的地址是入口地址（商品详情地址），造成支付成功后返回商品详情页面，打断了支付流程，所以在微博中用window.location.href跳转
          window.location.href = `${window.location.origin}/h5Pay/mall_compatible_order?itemid=${this.itemid}${this.putType ? '&put_type=1' : ''}${query}`
        } else {
          this.$router.push(
            `/h5Pay/mall_compatible_order?itemid=${this.itemid}${
              this.putType ? '&put_type=1' : ''
            }${query}`
          );
        }
        return;
      }
      //  分期购微信图层
      if (this.goodsDetail.fqFlag && obj && obj.group_buy && !this.ptFlag && env.isWeChat) {
        this.showHuabeiGui = true;
        return;
      }
      //  分期购点击
      if (obj && obj.group_buy && this.goodsDetail.fqFlag && !this.goodsDetail.recommendFlag && !this.ptFlag) {
        this.fqFlagMark = true;
      } else {
        this.fqFlagMark = false;
      }
      if (this.ptFlag) {
        if (obj && obj.group_buy) {
          this.ptSetTrack({ ...this.ptMaidian, module_name: '吸底', item_name: '拼团购买' }, 'click');
        } else {
          this.ptSetTrack({ ...this.ptMaidian, module_name: '吸底', item_name: '原价购买' }, 'click');
        }
      } else {
        if (this.goodsDetail.fqFlag && obj && obj.group_buy) {
          this.setTrack({ main_item_type: '分期', module_name: '吸底', item_name: '分期购买'  }, 'click');
        } else if (this.goodsDetail.couponUse) {
          this.setTrack({ page_name: '商城领券购详情页', btn_name: '领券购买' }, 'click');
        } else {
          if (this.userReallyOnline) {
            this.setTrack({ module_name: '底部', item_name: '单个购买按钮', btn_name: '购买' }, 'click');
          } else {
            this.setTrack({ module_name: '底部', item_name: '登陆和购买按钮', btn_name: '购买' }, 'click');
          }
          this.setTrack({ module_name: '浮层', item_name: '选择规格' }, 'show');
        }
      }
      if (this.isNoParamsCourse) {
        const { specilMapping } = this.goodsDetail;
        if (specilMapping[0].stockNum) {
          // 0元简化流程
          if (this.isSimpleProcess) {
            this.handlePlaceOrder();
            return;
          }

          const jumpUrl = `/h5Pay/mall_order?itemid=${this.itemid}&no_params=${true}${this.putType ? '&put_type=1' : ''}${query}${this.fqFlagMark ? '&fqFlag=1' : ''}`
          if (isInBaiduBrowser) {
            location.href = window.location.origin+jumpUrl;
          } else if (env.isApp) {
            JS2Native({
              name: 'navigateTo',
              params: {
                router: 'igetcool://juvenile.dedao.app/go/h5?params_url=' + encodeURIComponent(window.location.origin + jumpUrl)
              }
            }); 
          } else {
            this.$router.push(jumpUrl);
          }
          return;
        }
        return this.$coolToast({ text: '该课程已售罄' });
      }

      // jump 表示不再拉起规格面板，直接调用规格面板内的确定购买，跳转到收银台
      if (obj?.jump && this.$refs.sepcilPanel) {
        this.$refs.sepcilPanel.handleJumpClick();
        return;
      }
      
      // 实物商品且是未登录的情况下 先登录再弹出规格弹窗
      if(this.goodsDetail.goodsType == 6 && !this.userReallyOnline) {
        this.handleHalfScreenLogin(async () => {
          this.showSpecilPanl()
        });
      } else {
        this.showSpecilPanl()
      }
    },

    showSpecilPanl() {
      // 展示规格面板
      this.showCar = true;
      
      // 规格选择模太框弹出时上报买点
      // this.setLogTrack({ module_name: 'sku选择浮层' }, 'show');
      this.setLogTrack({ 
        module_name: '规格选择',
        old_module_name: 'sku选择浮层',
        key1: {
          goods_id: this.itemid,
          from: 2,
        }
      }, 'show');
    },

    async goodItemRequest() {
      // TODO 不知道这段代码有啥用，暂时注释，在getGoodDetail中增加此跳转逻辑 ======================
      // const { data: dataSellType } = await querySellType({ infoId: this.itemid });
      // // dataSellType.data=2
      // if (dataSellType.sellType === 2) {
      //   // 售卖流程(1常规 2新一键购 3 微信投放 4 老一键购 )
      //   // 商品是新一键购，当前在老一键购页面 需要跳转新一键购页面
      //   this.$router.replace({
      //     path: '/mall/oneKeyBuyNew' + location.search,
      //   });
      // }
      // ======================
      this.ajaxOk = false;
      let options = {
        infoId: this.itemid
      }
      // if(env.isApp && this.userReallyOnline) {
      //   options = {
      //     ...options,
      //     ...this.governmentPrice
      //   }
      // }
      // const { data } = await getGoodDetail({ infoId: this.itemid });
      const { data } = await getGoodDetail(options);
      this.handleGoodsDetail(data);
    },
    // 处理详情
    async handleGoodsDetail(data) {
      // 如果是新一贱购， 跳转到新一键购
      if (data.sellType === 2) {
        this.setRootLoading(false); 
        this.$router.replace({
          path: '/mall/oneKeyBuyNew' + location.search,
        });
      }

      // goodsType === 8 跳转到营地
      if (data.goodsType === 8) {
        this.setRootLoading(false); 
        this.$router.replace({
          path: '/mall/camp' + location.search,
        });
      }

      // 修改课包原价，根据商品id、规格id 写死
      // @aigc:start 2024/09/29-17:14
      const goodsIds = process.env.VUE_APP_ENVIRONMENT == 'PRODUCTION' ? ['1840282754314432513', '1840315341732462594'] : ['1840313263318032385'];
      if (data.goodsType == 7 && goodsIds.includes(this.itemid)) {
        data.packageSkuInfos.forEach(it => {
          if (it.id === '1840282754557702145') {
            it.originalPrice = 801;
          } else if (it.id === '1840315341870874625') {
            it.originalPrice = 761;
          } else if (it.id === '1840313263464833025') {
            it.originalPrice = 801;
          }
        });
      }
      // @aigc:end 2024/09/29-17:14
      
      
      // 如果支持添加购物车 || 开启预售并在预售阶段，获取购物车数量
      if (
        (data.isSupportShopCart && this.userReallyOnline) ||
        (this.preSaveData && this.preSaveData.isPreSaleDuring && this.userReallyOnline)) {
        getShoppingCount({ time: Date.now() }).then(res => {
          this.shoppingCount = res.data;
        });
      }
      
      this.showTypeTrue = data.showType === 1;
      this.handleScroll();
      this.commentlistData = data.commentInfos;
      this.commentId = data.commentId;
      this.detailInfo = (data.detailInfo && JSON.parse(data.detailInfo)) || [];
      this.isNoParamsCourse = this.isNoParamsCourseHandle(data);
      if (this.isNoParamsCourse) {
        data.upSpecil = [];
        data.downSpecil = [];
      }
      // 已登录，是兑换卡池中的课程查询开卡信息
      let memberSkip = await getMemberSkip({goodsId: this.itemid, type: 1})
      this.openVipInfo = memberSkip.data || {};

      // 是vip用户且该商品能够进行兑换的情况下， 查询兑换信息
      if (this.userReallyOnline && this.openVipInfo.isGoodsBoughtVip && this.openVipInfo.isUserVip) {
        let pool = await getExchangePool({goodsId: this.itemid})
        this.exchangePoolInfo = pool.data || {};
      }

      this.getProductInfo(data);
      if (this.skuOpen && !sessionStorage.getItem('isNoParamsCourse')) {
        if (this.isNoParamsCourse) {
          let query = '&';
          for (let key in this.otherQuery) {
            query += `${key}=${this.otherQuery[key]}&`;
          }
          query = query.substr(0, query.length - 1);
          const { specilMapping } = data;

          let jUrl = `/h5Pay/mall_order?itemid=${this.itemid}&no_params=${true}${this.putType ? '&put_type=1' : ''}${query}`
          if (specilMapping[0].stockNum) {
            if (env.isWeChat || isInBaiduBrowser) {
              if (this.skuOpen == 2) {
                window.location.replace(jUrl);
              } else {
                location.href = jUrl;
              }
            } else if (env.isApp) {
              if (this.skuOpen == 2) {
                // skuOpen 为2时，在客户端内正常跳转，当前页面会自动退回到上一页
                JS2Native({
                  name: 'navigateTo',
                  params: {
                    router: 'igetcool://juvenile.dedao.app/go/h5?params_url=' + encodeURIComponent(window.location.origin + jUrl),
                  }
                });

                setTimeout(() => {
                  this.$router.go(-1);
                }, 1500)
              } else {
                // 由于性能优化，APP内需要使用鲁班系统，到结算台页面需要刷新路由地址，因此APP内跳转更改为使用JS2Native
                JS2Native({
                  name: 'navigateToParams',
                  params: {
                    router: 'igetcool://juvenile.dedao.app/go/h5?params_url=' + encodeURIComponent(window.location.origin + jUrl),
                    exit: 'true'
                  }
                }); 
              }
              
            } else {
              if (this.skuOpen == 2) {
                this.$router.replace(jUrl);
              } else {
                this.$router.push(jUrl);
              }
            }
            return;
          }
          return this.$coolToast({ text: '该课程已售罄' });
        } else {
          this.showCar = true;
        }
      }
      if (env.isWeChat) {
        if (this.ptFlag) {
          let shareTitle = `《${data.name}》课程拼团啦`;
          let shareDes = '拼团活动太划算了，找伙伴们一起学习吧！';
          const shareData = {
            title: this.ptInfo.ptActivityBasicRespDto.goodsShareTitle || shareTitle,
            // link: `${location.origin}/mall/course?itemid=${this.itemid}&ptFlag=${this.ptFlag}&igc_from=${this.igc_from || 'xxx'}`,
            link: document.URL,
            desc: this.ptInfo.ptActivityBasicRespDto.goodsShareDesc || shareDes,
            imgUrl: this.ptInfo.ptActivityBasicRespDto.goodsShareAppPic || 'https://coolcdn.igetcool.com/p/2020/10/613f787d463b9dc5032fa3919ba18f80.png?_200x200.png'
          };
          this.weChatShareConfig(shareData);
          this.putShareConfigToLocaStorage(shareData);
        } else {
          data && this.shareConfigHandle(data);
        }

        // 如果是实物商品，禁止微信分享
        // if (data.goodsType == 6) {
        //   window.WeixinJSBridge.call('hideOptionMenu');
        // }
      }
      setTimeout(() => {
        if (this.userReallyOnline) {
          this.setTrack({ module_name: '底部', item_name: '单个购买按钮' }, 'show');
        } else {
          this.setTrack({ module_name: '底部', item_name: '登陆和购买按钮' }, 'show');
        }
      }, 2000);

      this.ajaxOk = true;
    },
    shareConfigHandle(course) {
      let shareConfig;
      let query = '?';
      let url = '';
      for (let key in this.$route.query) {
        query += `${key}=${this.$route.query[key]}&`;
      }
      query = query.substr(0, query.length - 1);
      if (this.abFlag && ILocalStorage('abID')) {
        url = `${location.origin}/mall/curriculum?at_id=${ILocalStorage('abID')}&igc_from=${this.igc_from}`;
      }
      shareConfig = {
        title: `【少年得到】「${course.name}」${this.itemid === '1344201586981552130' ? '' : '点击立即报名'}`,
        link: this.abFlag ? url : `${location.origin}/mall/course${query}`,
        desc: `${this.itemid === '1344201586981552130' ? '每天欢笑十分钟，启蒙千年世界史' : `点击立即报名「${course.name}」`}`,
        imgUrl: course.coverImg
      };
      this.putShareConfigToLocaStorage(shareConfig);
      this.weChatShareConfig(shareConfig);

      
    },
    putShareConfigToLocaStorage(shareConfig) {
      ILocalStorage(
        'shareConfig',
        JSON.stringify({
          itemid: this.itemid,
          ...shareConfig
        })
      );
    },
    weChatShareConfig(shareConfig) {
      webSDK.setShare({
        title: shareConfig.title,
        link: shareConfig.link,
        desc: shareConfig.desc,
        imgUrl: shareConfig.imgUrl
      });
    },
    
    // @aigc:start 2024/07/01-10:07
    setRootLoading(bj = false) {
      try {
        const rootInstance = this.$root.$children[0];
        rootInstance.pageLoading = bj;
      } catch (error) {
      }
    },
    // @aigc:end 2024/07/01-10:07
    
    getProductInfo(data) {
      let { upSpecil, downSpecil } = data;

      // 给 upSpecil, downSpecil 添加selected属性并触发响应式
      upSpecil = upSpecil.map(item => {
        item.selected = false;
        item.stockTips = '';
        item.display = true;
        return item;
      });
      downSpecil = downSpecil.map(item => {
        item.selected = false;
        item.stockTips = '';
        item.display = true;
        return item;
      });

      // 遍历skuCouponMapping， 将会员券价格与优惠券价格合并
      // @aigc:start 2024/03/05-14:02
      try {
        if (data?.skuCouponMapping) {
          const skuCouponMappingKeys = Object.keys(data.skuCouponMapping);
          skuCouponMappingKeys.forEach(key => {
            const item = data.skuCouponMapping[key];
            if (item.membershipCoupons && item.membershipCoupons?.discount) {
              item.discountPrice = add(item.membershipCoupons.discount, item.discountPrice || 0);
            }

            /**
             *  - 权益价：售价 - 活动组合，最终展示“权益价：￥{good.price}” （只要有会员卡券直接展示权益价）
             *  - 活动（立减）：售价 - 活动价（（早鸟 立减）），最终展示“{优惠活动名称}￥{good.price}” 
             *  - 券后+立减：售价 - 券 - 活动，最终展示“优惠价￥{good.price}”
             *  - 券后：售价 - 可用优惠券（满减或者现金），最终展示“券后￥{good.price}”
             * 
             * 有会员使用类型 1-会员价 2-早鸟价 3-优惠价 4-券后价 5-立减价
             * 1.权益价（多个共存 存在会员券取会员价 ）
             * 2.早鸟价（仅存在早鸟价叫早鸟价） 活动立减
             * 3.优惠价 （优惠券+立减，多个共存并且包括早鸟价）
             * 4.券后价 （满减或者现金）
             * 5.立减价（文案读取立减配置，仅存在立减）
             */
            // @aigc:start 2024-10-22-14:33
            let showType = 0;
            let couponUseText = '';
            if (item.discountPrice && data.showCouponPrice || item.membershipCoupons &&
             item.membershipCoupons.discount && data.showCouponPrice) {
              // 存在优惠券（满减 || 现金 ）
              // 且后台设置了展示券后价 1-展示 0-不展示
              showType = 4;
              couponUseText = '券后价'

              if(data.reduceFlag || data.birdPrice) {
                //且存在 立减 || 早鸟价 即（优惠券 + 立减）
                showType = 3;
                couponUseText = '优惠价'
              }
            } else if(data.birdPrice) {
              // 存在早鸟价
              showType = 2;
              couponUseText = data.birdRemark || ''
            } else if(data.reduceFlag) {
              // 存在立减
              showType = 5;
              couponUseText = data.reduceActivityName || ''
            }
            item.couponUseType = showType
            item.couponUseText = couponUseText
            // @aigc:end 2024-10-22-14:33

            //优惠券计算类型结束

          });
        }
      } catch (error) {
      }
      // @aigc:end 2024/03/05-14:02
   
      this.goodsDetail = data;
      this.setRootLoading(false); 
      // @aigc:start 2024/11/20-18:23
      try {
        setTimeout(() => {
          var loading = document.getElementById('newLoading');
          loading.style.display = 'none';
        }, 1000);
      } catch (error) {
      }
      // @aigc:end 2024/11/20-18:23

      /*  获取规格组合的第一个组规格  */
      if (!this.goodsDetail.couponUse && this.goodsDetail.skuCouponMapping) {
        if (this.isNoParamsCourse) {
          let getKey;
          for (let key in this.goodsDetail.skuCouponMapping) {
            getKey = key;
          }

          let firstSkuObj = this.goodsDetail.specilMapping[0];

          // showCouponPrice 是否展示券后价 1: 展示 0:不展示
          if (this.goodsDetail.showCouponPrice) {
            this.firstSelectSkuDiscountPrice = this.goodsDetail.skuCouponMapping[getKey].discountPrice;
          }
          // 首规格是否使用了会员券
          this.firstSelectSkuVipCouponUse = this.goodsDetail.skuCouponMapping[getKey].membershipCoupons && this.goodsDetail.skuCouponMapping[getKey].membershipCoupons.discount;
          // 首规格使用优惠券类型
          this.firstSelectSkuCouponUseType = this.goodsDetail.skuCouponMapping[firstSkuObj.skuId].couponUseType
        } else {
          // TODO 用上规格的第一个 拼接 下规格的第一个 得到的firstSkuObj可能不存在，会抛出异常，打断后面代码的执行，所以用try包一下，等续费过后，这里的逻辑再调整一下
          try {
            let strSpecil;
            if (this.goodsDetail.upSpecil && this.goodsDetail.upSpecil.length) {
              strSpecil = `${this.goodsDetail.upSpecil[0].specilId}-`;
            }
            if (this.goodsDetail.downSpecil && this.goodsDetail.downSpecil.length) {
              strSpecil = `${strSpecil}${this.goodsDetail.downSpecil[0].specilId}-`;
            }
            let firstSkuObj = this.goodsDetail.specilMapping.find(data => {
              return data.key === strSpecil;
            });
     
            if (this.goodsDetail.skuCouponMapping) {
              if (this.goodsDetail.showCouponPrice){
                this.firstSelectSkuDiscountPrice = this.goodsDetail.skuCouponMapping[firstSkuObj.skuId].discountPrice;
              }
              // 首规格是否使用了会员券
              this.firstSelectSkuVipCouponUse = this.goodsDetail.skuCouponMapping[firstSkuObj.skuId].membershipCoupons && this.goodsDetail.skuCouponMapping[firstSkuObj.skuId].membershipCoupons.discount;
              // 首规格使用优惠券类型
              this.firstSelectSkuCouponUseType = this.goodsDetail.skuCouponMapping[firstSkuObj.skuId].couponUseType
            }
          } catch (error) {

          }
        }
      }
      /*  获取规格组合的第一个组规格  */
      this.relationSaleRespDTOList = data.relationSaleRespDTOList;

      // TODO 2023-02-02 课包售卖临时修改，根据商品id固定页面title -- bengin
      let pageTitle = data.title;
      try {
        let pageTitleMap = {
          '1614184832593272833':'五阶知识拓展课包',
          '1615189362436972545':'四阶知识拓展课包',
          '1615189575495032833':'三阶知识拓展课包',
          '1615189827468951554':'二阶知识拓展课包',
          '1615190126869848066':'一阶知识拓展课包',
          '1621050404491264001':'六阶知识拓展课包',
        }
        pageTitle = pageTitleMap[this.itemid] || data.title;
      } catch (error) {
      }
      this.setTitle(pageTitle);
      // TODO 2023-02-02 课包售卖临时修改，根据商品id固定页面title -- over

      let obj = {};
      if (this.uId) { obj.uid = this.uId }
      if (this.instructor) { obj.instructor = this.instructor }
      if (this.ptFlag) {
        this.ptSetTrack({ ...this.ptMaidian, ...obj }, 'page');
      } else {
        if (this.goodsDetail.couponUse) {
          this.setTrack({ page_name: '商城领券购详情页', ...obj }, 'page');
        } else {
          this.setTrack(obj, 'page');
        }
      }

      // 进入页面上报page埋点
      let key1 = {module_name: '商品曝光'};
      // ABTest上报信息
      if (this.abFlag && ILocalStorage('abID')) {
        let abinfo = ILocalStorage('abID');
        key1.abID = JSON.parse(ILocalStorage(abinfo)).abActivityId;
        key1.abBucket = JSON.parse(ILocalStorage(abinfo)).bucketName;
      }
      this.setLogTrack({ key1 }, 'page');

      // 判断是否购买了商品，toast提示
      if (this.goodsDetail.boughtCount && this.goodsDetail.whetherAudition) {
        this.$coolToast({
          text: '已经购买了该课程',
          time: 1500
        });
      }
    
      // 拼团埋点（火山）
      this.ptFlag && this.$tracker('sndd_hs_group_buy_open_group_page_view', {
        sndd_product_id: [this.itemid],
        product_title: [this.goodsDetail.name],
      });
    },

    // 设置页标题
    setTitle(title = '少年得到') {
      if (env.isApp) {
        JS2Native({
          name: 'setPageTitle',
          params: {
            title,
          }
        });
      } else {
        document.title = title;
      }
    },
    goToCommentlist() {
      this.setTrack({ module_name: '页面', item_name: '更多评价', btn_name: '更多评价' }, 'click');
      this.$router.push({
        path: `/mall/more-comment?commentId=${this.commentId}`
      });
    },
    clickTool() {
      this.setTrack({ module_name: '浮层', item_name: '订单和客服聚合图标', btn_name: '订单和客服聚合图标' }, 'click');
      this.setLogTrack({ btn_name: '联系客服' }, 'click');
    },
    goToOrder() {
      if (this.ptFlag) {
        this.ptSetTrack({ ...this.ptMaidian, module_name: '头部', btn_name: '订单列表' }, 'click');
      } else {
        this.setTrack({ module_name: '浮层', item_name: '订单和客服聚合图标', btn_name: '我的订单' }, 'click');
      }
    },
    goToIM() {
      this.setTrack({ module_name: '浮层', item_name: '订单和客服聚合图标', btn_name: '咨询客服' }, 'click');
    },
    isNoParamsCourseHandle(data) {
      const { specilMapping } = data;
      return !!(specilMapping.length && specilMapping[0].key === 'none');
    },
    setTrack(options = {}, type = 'show') {
      let oldOP = {
        page_name: '商城详情页',
        page_type: 2,
        page_title: document.title,
        url: location.href,
        main_item_id: this.itemid,
        mall_channel: this.igc_from
      };
      if (this.campType === '1') {
        oldOP.page_name = '体验课领取页';
      } else if (this.campType === '2') {
        oldOP.page_name = '课程售卖详情页';
      }
      if (this.mini_camptype === '0') {
        oldOP.key2 = '阅读营';
      } else if (this.mini_camptype === '1') {
        oldOP.key2 = '魔术营';
      } else if (this.mini_camptype === '2') {
        oldOP.key2 = '写字营';
      }
      let newOP = Object.assign({}, oldOP, options);
      newOP.key1 = JSON.stringify(newOP.key1)
      LogTrack.track(newOP, type);
    },
    inAppGetUserInfo() {
      JS2Native({
        name: 'getAppUserPid'
      }).then(({ data }) => {
        if (data) {
          const uid = data;
          JS2Native({
            name: 'getUserInfo'
          }).then(({ data }) => {
            const userInfo = {};
            userInfo['App-Device-Key'] = data['App-Device-Key'];
            userInfo['App-Device-Type'] = data['App-Device-Type'];
            userInfo['App-Device-Du-Key'] = data['App-Device-Du-Key'];
            userInfo['APP-Agent'] = data['App-Version'];
            userInfo['App-Sign'] = data['App-Token'];
            userInfo['App-Channel'] = data['App-Channel'];
            userInfo['isLogin'] = data['isLogin'];
            userInfo['App-nickName'] = data['nickName'];
            userInfo['uid'] = uid;

            userInfo['App-Version'] = data['App-Version'];
            
            this.governmentPrice = {
              appChannel: data['App-Channel'],
              isLogin: data['isLogin'],
              deviceType: data['App-Device-Type'],
              appVersion: data['App-Version']
            }
            setUser(JSON.stringify(userInfo));
            this.userId = uid;
            this.loginOnline = true;
            this._loginCheck();
          });
        } else {
          removeUser();
          this._loginCheck();
        }
      });
    },
    setPrice(price, index) {
      price = '' + price;
      return price.split('.')[index];
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'itemid') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    initFunc() {
      this.showCar = false;
      this.goodsDetail = {};
    },

    // 2020.2.25 新增埋点处理
    setLogTrack(params, action) {
      // activity_id：小货架活动id
      // user_id：用户id
      // good_status：1预售，2可售卖，3不在售卖期
      // trolley_status：1可加购、2不可加购
      // whetherAudition: 0非试听试看、1试听试看
      let good_status
      if (this.preSaveData && this.preSaveData.isPreSaleDuring) {
        good_status = 1;
      } else if (this.goodsDetail.productStatus) {
        good_status = 2;
      } else {
        good_status = 3
      }
      
      let log = {
        user_id: this.uId || '',
        trolley_status: this.goodsDetail.isSupportShopCart ? 1 : 2,
        activity_id: this.$route.query.shoppingPolymerizeId || '',
        good_status,
        goods_id: this.itemid,
        whetherAudition: this.goodsDetail.whetherAudition,
        product_type: this.goodsDetail.productType,
        platform: 'h5',
      }
      if (this.ptFlag) {
        log.group_page = 1;  // 1开团页 2参团邀请页
      }
      if (params.key1) {
        params.key1 = {
          ...log,
          ...params.key1
        }
      } else {
        params.key1 = log
      }

      // 0元购流程简化
      if (this.isSimpleProcess) {
        params.key1.zeroSimplifyFlow = 1;
      }

      this.$logReport({ 
        params: { 
          page_name: '商品详情页', 
          main_item_type: this.goodsDetail.productType,
          ...params 
        }, 
        action, 
        goodsDetail: this.goodsDetail });
    },

    // 兑换课程啦
    exchangeVip() {

      if(!this.userReallyOnline) {
        this.toLogin();
        return
      }

      if(this.openVipInfo.isUserVip) {
        this.setTrack({
          module_name: '底部按钮',
          item_name: '兑换课程',
          btn_name: '兑换课程',
          key1: {
            inCoursePool: this.exchangePoolInfo.defaultPoolId ? 1 : 0,
            exchangeNum: this.exchangePoolInfo.defaultCanChangeCount ? 1 : 0,
            inUserPool: 1,   // 是否符合人群
          }
        }, 'click');
        this.vipPopShow = true

        this.setTrack({
          module_name: '兑换弹窗',
          key1: {
            inCoursePool: this.exchangePoolInfo.defaultPoolId ? 1 : 0,
            exchangeNum: this.exchangePoolInfo.defaultCanChangeCount ? 1 : 0,
            inUserPool: 1,   // 是否符合人群
          }
        }, 'show');
        return
      }

      if(!this.openVipInfo.vipGoodsUrl) {
        return
      }

      // @aigc:start 2024/08/01-13:51
      if (env.isHarmony && !env.isApp) {
        this.$coolToast({ text: '此功能鸿蒙系统暂不支持，后续版本解决' });
        return;
      }
      // @aigc:end 2024/08/01-13:51

      let vipUrl = this.openVipInfo.vipGoodsUrl;
      vipUrl = vipUrl + '&vip_course_id=' + this.goodsDetail.specilMapping[0].cmsProductId;
      // 是会员权益商品当时不是会员，则去会员购买页面
      if(env.isApp) {
        coolHref(vipUrl)
      } else {
        let url = vipUrl.split('/mall/vipCard')
        this.$router.push({
          path: `/mall/vipCard${url[1]}`,
        });
      }
    },

    // 确认兑换啊
    sureChange() {
      this.setTrack({
        module_name: '兑换弹窗',
        item_name: '兑换',
        btn_name: '兑换',
        key1: {
          inCoursePool: this.exchangePoolInfo.defaultPoolId ? 1 : 0,
          exchangeNum: this.exchangePoolInfo.defaultCanChangeCount ? 1 : 0,
          inUserPool: 1,   // 是否符合人群
        }
      }, 'click');
      if(this.loadingVisible) {
        this.$coolToast({ text: '请勿重复兑换!' });
        return
      }
      this.loadingVisible = true;
      
      postExchangePoolSub({ 
        goodsId: this.itemid, 
        source: this.igc_from ? this.igc_from : 'vip_mall',
        defaultPoolId: this.exchangePoolInfo.defaultPoolId
      }).then(async (res) => {
        this.loadingVisible = false;
        let pool = await getExchangePool({goodsId: this.itemid})
        this.changeSucc = true;
        this.exchangePoolInfo = pool.data || {};
      }).catch(err => {
        this.loadingVisible = false;
      });

    }
  },

  beforeDestroy() {
    this.initFunc();
    
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollFunc);
    if (this.$route.path != '/h5Pay/mall_order') {
      this.setRootLoading(false);
    }
  },

  components: {
    CoolMLoading,
    shopCarV2,
    BottomBtn,
    CommentList,
    TopBarNav,
    FixedShrink,
    HuabeiCeng,
    IDelTag,
    BuyNotice,
    Countdown,
    MallSpecilPopup,
    CourseContent,
    Logout,
    VipBenefits,
  }
};
</script>

<style lang="stylus" scoped>
.product-item {
  padding-bottom: calc(0.80rem + env(safe-area-inset-bottom));
  &.product-item__oneshoping{
    padding-bottom: calc(105px + constant(safe-area-inset-bottom));
    padding-bottom: calc(105px + env(safe-area-inset-bottom));
  }

  &.product-item--hide {
    display: none;
  }

  .lianbao-btn {
    position: fixed;
    left: 12px;
    bottom: 65px;
    justify-content: space-between;
    display: flex;


    img {
      width: 175px;
      height: 56px;
    }
  }

  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .lianbao-btn {
      bottom: 95px;
    }
  }

  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    .lianbao-btn {
      bottom: 95px;
    }
  }

  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
    .lianbao-btn {
      bottom: 95px;
    }
  }

  .active-wrap {
    position: fixed;
    right: 0;
    top: 31px;

    .icon {
      display: inline-block;
      width: 24px;
      height: 24px;
      background-size: 24px 24px;

      &.share {
        background-image: url('./images/nav_second_icon_share_white@3x.png');
      }

      &.list {
        background-image: url('./images/h5_payment_icon_my_ order@3x.png');
      }
    }

    .inner {
      background: #ffffff;
      border-top-left-radius: 16px;
      border-bottom-left-radius: 16px;
      padding: 12px 8px;
    }

    .active-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .name {
        font-size: 10px;
        font-weight: 500;
        line-height: 14px;
        color: #41414D;
        margin-top: 2px;
      }
    }
  }
  .pop_content {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    z-index: 999;
    .main {
      position relative
      display flex
      flex-direction column
      width 100%
      height 3.1rem
      padding-top .2rem
      background-color white
      .close_icon {
        position absolute
        right .2rem
        top .2rem
      }
      .title {
        text-align center
        font-size .18rem
        color #41414D
      }
      .content {
        flex 1
        margin-top .2rem
        padding 0 .2rem .2rem .2rem
        font-size .14rem
        line-height .2rem
        color #6D6D80
        overflow-y scroll
        -webkit-overflow-scrolling touch
      }
    }
  }
}

.tips-wrap {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #A1A1B3;
  line-height: 17px;
  width: 100%;

  .coupons-tips {
    line-height: 14px;
    padding: 0 2px;
    border: 1px solid #FF5F2E;
    border-radius: 3px;
    color: #FF5F2E;
    margin-left: 2px;
  }
}

.goods-price-wrap {
  display: flex;
  align-items: flex-end;
  margin-bottom: 2px;

  &.extra-wrap {
    align-items: flex-start;
  }

  .sale-price {
    display: flex;
    align-items: flex-end;
    color: #FF5F2E;

    span.icon {
      font-size: 14px;
      font-weight: 700;
      line-height: 14px;
    }

    span.price {
      line-height: 20px;
      font-size: 20px;
      font-family: Oswald-Medium;

      &.small {
        line-height: 14px;
        font-size: 14px;
      }
    }
  }

  .actual-price {
    display: flex;
    color: #C2C2CC;
    align-items: center;
    line-height: 14px;
    font-size: 12px;
    text-decoration: line-through;
  }

  .reduce-price {
    display: flex;
    align-items: center;
    color: #41414D;
    line-height: 16px;

    span.icon {
      font-size: 14px;
      font-weight: 700;
    }

    span.price {
      font-family: Oswald-Medium;
      font-size: 14px;
    }

    .tag {
      margin-left: 5px;
      position: relative;
      background: #FF5F2E;
      color: #FFFFCB;
      font-size: 10px;
      font-weight: 700;
      line-height: 14px;
      padding: 0 2px;
      border-bottom-left-radius: 4px;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;

      &::before {
        content: ' ';
        width: 5px;
        height: 100%;
        position: absolute;
        background-image: url('./images/h5_label_laosheng1.png');
        background-size: 5px 100%;
        margin-left: -6px;
      }
    }
  }
}

.ifooter_area_container_new {
  height: 56px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  padding: 8px 20px;
  box-sizing: border-box;
  background-color: #fff;
  justify-content: space-between;

  .noCreatePtClass {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    top: -24px;
    width: 100%;
    height: 24px;
    color: #FF3526;
    font-size: 12px
    background-color: #FFEAEA;
    img {
      width: 16px;
      height: 16px;
    }
  }

  .goods-price-wrap {
    display: flex;
    align-items: center;

    &.extra-wrap {
      align-items: flex-start;
    }

    .sale-price {
      display: flex;
      align-items: flex-end;
      color: #FF5F2E;

      span.icon {
        font-size: 14px;
        font-weight: 700;
        line-height: 14px;
      }

      span.price {
        line-height: 20px;
        font-size: 20px;
        font-family: Oswald-Medium;

        &.small {
          line-height: 14px;
          font-size: 14px;
        }
      }
    }

    .actual-price {
      display: flex;
      color: #C2C2CC;
      align-items: center;
      line-height: 14px;
      font-size: 12px;
      text-decoration: line-through;
      margin-left: 10px;
      margin-top: 8px;
    }

    .priceRemark {
      background-color: #FF5440;
      padding: 8px 10px;
      position: absolute;
      top: -15px;
      left: 16px;
      font-size: 11px;
      color: #FFE9C2;
      border-radius: 8px;

      &:after {
        position: absolute;
        left: 10px;
        bottom: -8px;
        display: block;
        content: '';
        width: 0;
        height: 0;
        border: 4px solid rgba(0, 0, 0, 0);
        border-top-color: #FF5440;
      }
    }

    .reduce-price {
      display: flex;
      align-items: center;
      color: #41414D;
      line-height: 16px;

      span.icon {
        font-size: 14px;
        font-weight: 700;
      }

      span.price {
        font-family: Oswald-Medium;
        font-size: 14px;
      }

      .tag {
        margin-left: 5px;
        position: relative;
        background: #FF5F2E;
        color: #FFFFCB;
        font-size: 10px;
        font-weight: 700;
        line-height: 14px;
        padding: 0 2px;
        border-bottom-left-radius: 4px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;

        &::before {
          content: ' ';
          width: 5px;
          height: 100%;
          position: absolute;
          background-image: url('./images/h5_label_laosheng1.png');
          background-size: 5px 100%;
          margin-left: -6px;
        }
      }
    }
  }

  .igcc-button-group {
    display: flex;

    button {
      font-size: 15px;
      color: #fff;
      min-width: 120px
      height: 40px
      /*padding: 10px 15px;*/
    }

    .login-btn {
      background-color: #FF9800;
      border-bottom-left-radius: 20px;
      border-top-left-radius: 20px;
    }

    .hidden {
      display: none;
    }

    .buy-btn {
      background-color: #FF5F2E;
      border-bottom-right-radius: 20px;
      border-top-right-radius: 20px;
    }

    .logined-buy-btn {
      background-color: #FF5F2E;
      border-radius: 20px;
    }

  }
  .group_buy_btn {
    display: flex;
    button {
      font-size: 15px;
      color: #fff;
      min-width: 168px
      height: 40px
    }
    .left_btn {
      color: #FF5F2E;
      background-color: #FFEAE0;
      border-bottom-left-radius: 20px;
      border-top-left-radius: 20px;
      .priceRemark {
        background-color: #FF5440;
        padding: 8px 10px;
        position: absolute;
        top: -15px;
        font-size: 11px;
        color: #FFE9C2;
        border-radius: 8px;

        &:after {
          position: absolute;
          left: 10px;
          bottom: -8px;
          display: block;
          content: '';
          width: 0;
          height: 0;
          border: 4px solid rgba(0, 0, 0, 0);
          border-top-color: #FF5440;
        }
      }
      .sale-price {
        display: flex;
        align-items: baseline;
        justify-content: center;
        color: #FF5F2E;

        span.icon {
          font-size: 16px;
          font-weight: 700;
          line-height: 14px;
        }

        span.price {
          line-height: 20px;
          font-size: 16px;
          font-family: Oswald-Medium;

          &.small {
            line-height: 14px;
            font-size: 10px;
          }
        }
      }
      .buy_text {
        font-size: .12rem;
      }
    }
    .right_btn {
      background-color: #FF5F2E;
      border-bottom-right-radius: 20px;
      border-top-right-radius: 20px;
      .sale-price {
        display: flex;
        align-items: baseline;
        justify-content: center;

        span.icon {
          font-size: 16px;
          font-weight: 700;
          line-height: 14px;
        }

        span.price {
          line-height: 20px;
          font-size: 16px;
          font-family: Oswald-Medium;

          &.small {
            line-height: 14px;
            font-size: 10px;
          }
        }
      }
      .buy_text {
        font-size: .12rem;
      }
    }
  }
}

.gift-modal {
  width 100%
  height 100%
  background-color rgba(0, 0, 0, .6)
  position: fixed;
  top: 0
  left: 0
  right: 0
  bottom: 0
  z-index: 10;
  .gift-modal-content {
    width: 100%
    height: 100%
    display: flex;
    justify-content center
    align-items center

    .img-gift-wrap {
      width: 100%
      height: 458px
      background url("../../assets/images/giftBg.png")
      background-size cover
      position relative
    }
    .img-gift-wrap_n {
      width: 100%
      height: 458px
      background url("../../assets/images/giftBg2.png")
      background-size cover
      position relative
    }

    .title {
      color #F3A86A
      font-size: 20px
      text-align center
      margin-top: 90px
      font-weight: 500
    }

    .title-name {
      color #EB3832
      text-align center
      margin-top: 10px
      display flex
      justify-content center
      align-items center

      .num {
        font-size: 52px
        font-weight: 500
      }

      .unit {
        font-size: 30px
        font-weight: 700
        margin-top: 10px
      }
    }

    .range {
      color #41414D
      font-size: 14px
      padding-left: 90px
      margin-top: 30px
      font-weight: 700
    }

    .range-name {
      color #41414D
      font-size: 14px
      padding-left: 90px
      padding-right: 85px;
      margin-top: 5px
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      /*overflow: scroll;*/
      padding-top: 3px
    }

    .get-gift {
      width: 80px
      height: 80px
      margin-left: 145px
      margin-top: 40px
    }

    .time-item {
      color #EB3832
      font-size: 14px
      position: absolute;
      top: 410px;
      width: 100%
      text-align center
    }
  }
}

.gift-enter-active, .gift-leave-active {
  transition: opacity .5s;

}

.gift-enter, .gift-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;

}
</style>
